<template>
  <v-container>
    <v-card class="py-4 px-3">
      <v-layout column wrap>
        <v-layout wrap>
          <v-card-text class="text-xs-left mr-3 ml-3"><h3>Статус заявки: {{dataApp.status.status.name}}</h3> </v-card-text>
          <v-btn  class="primary mr-3 ml-3" @click="opened_form_status = true" v-if="allowed('admin|petition|petition|petition_create_council-change-status', 'change_status')">Изменить статус заявки</v-btn>
          <v-btn class="primary mr-3 ml-3" @click="printPDF" v-if="allowed('admin|petition|petition|petition_create_council-make-file', 'make_file')">Сформировать PDF</v-btn>
        </v-layout>
        <v-card-text class="text-xs-left mr-3 ml-3" v-if="dataApp.status.motivation"><h3>Причина изменения статуса: {{dataApp.status.motivation}}</h3></v-card-text>
      </v-layout>
      <v-card-text class="text-xs-left mr-3 ml-3"> <h3>Подразделения:</h3>
        <v-sheet
          class="pa-1"
          color="grey lighten-3"  v-for="(item, index) in dataApp.departments ">{{dataApp.departments[index].uid}}</v-sheet>
      </v-card-text>
      <v-card-text class="text-xs-left mr-3 ml-3"> <h3>Специальности:</h3>
        <v-sheet
          class="pa-1"
          color="grey lighten-3"  v-for="(item, index) in dataApp.specialities ">{{item.speciality}}-{{item.branch}}</v-sheet>
      </v-card-text>
      <v-card-text class="text-xs-left mr-3 ml-3"><h3> Ответственный: {{dataApp.responsible}}</h3></v-card-text>




    </v-card>
    <v-dialog persistent v-model="opened_form_status" width="600">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Смена статуса</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-toolbar-items>
              <v-btn @click="opened_form_status = false" class="pa-0 ma-0" dark flat icon>
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <ChangeStatus
          v-bind:id="dataApp.status.status.id" typeSt="app"
          @ended="closedForm"
        >
        </ChangeStatus>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
  import urlsW from "../urlsW.js"
  import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
  import urls from "../urls.js"
  import {makeManagerUrl, makeGetRequest, getErrorArray, makePostRequest} from "../../../helper";
  import ChangeStatus from "../forms/ChangeStatus.vue"

    export default {
      name: "DetailApplication",
      mixins: [UserDataFormMixin],
      components: {
        ChangeStatus
      },
    data: function () {
      return {

        opened_form_status: false,
        dataApp:{
          "status":{"status":"null"},
          "responsible":null,
          "departments":null,
        },
        selectors: {
          department: [],
        },
      }

    },
    methods: {
      download(content, fileName, contentType) {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(content);
        a.download = fileName;
        a.click();
      },
      allowed(urlname, action) {
        return urls.getUrlAllowed(urlname, action)
      },
      printPDF(){
        let status = true;
        const type = "application/pdf";
        const name = 'file';
        makeGetRequest(
          urls.getUrl('admin|petition|petition|petition_create_council-make-file', 'make_file').replace('<id>', this.$route.params.id),
        ) .then(resp => {
          if (!resp.ok) {
            status = false;
          }
          return resp.blob();
        }) .then(blob => {
          this.download(blob, name, type);

        })

      },
      closedForm: function () {
        this.opened_form_status = false
        this.alert = true
        this.getData();
      },
        setDepartment(){
          for (var key in this.dataApp.departments) {
            var dep = this.selectors.department.find(department => department.value === this.dataApp.departments[key].uid);
            this.dataApp.departments[key].uid = dep.text
          }
        },
        getData(){
          makeGetRequest(
            urls.getUrl('admin|petition|petition|petition_create_council-detail', 'retrieve').replace('<id>', this.$route.params.id),
          ).then(resp => resp.json())
            .then(json => {
              this.dataApp = json
              this.setDepartment()
              makeGetRequest(urlsW.getUrl('profile_worker-title', 'title').replace('<user>', this.dataApp.responsible) ).then(
                resp => resp.json())
                .then(json => {
                  this.dataApp.responsible = json.title
                })
            })
        }

    },
    created() {

      this.$store.commit('mainpage/changeTitle', 'Дисс совет');
      this.getData();
      this.getChoices(
        urlsW.getUrl('selectors|department-uid', 'get').replace('<organization_id>', '1'),
      ).then(choices => {
        this.selectors.department = choices
        this.setDepartment()
      });

    },

    }
</script>

<style scoped>

</style>
